import request from '@/utils/request3'
import store from '@/store'
const serviceName = store.state.serviceName.goodsSystem
import qs from 'qs'

// 新增采购单
export function addBuyPurchase(data) {
    return request({
        url: serviceName + `/add_xz_purchase`,
        method: 'post',
        data: data
    })
}

// 获取采购单列表
export function getBuyPurchase(data) {
    return request({
        url: serviceName + `/xz_purchase_list`,
        method: 'post',
        data: data
    })
}

// 查询采购单明细
export function queryXzPurchase(data) {
    return request({
        url: serviceName + `/query_xz_purchase`,
        method: 'post',
        data: data
    })
}

// 更新采购单的基本信息
export function updateXzPurchase(data) {
    return request({
        url: serviceName + `/update_xz_purchase`,
        method: 'post',
        data: data
    })
}

// 采购单货物明细变更
export function updatePurchaseGoods(data) {
    return request({
        url: serviceName + `/update_purchase_goods`,
        method: 'post',
        data: data
    })
}

// 货物采购修改-新增采购货物明细
export function addXzPurchaseGoods(data) {
    return request({
        url: serviceName + `/add_xz_purchase_goods_list`,
        method: 'post',
        data: data
    })
}

// 删除采购单信息
export function deletePurchaseList(data) {
    return request({
        url: serviceName + `/delete_purchase_list`,
        method: 'post',
        data: data
    })
}

// 删除采购单货物信息
export function deletePurchaseGoods(data) {
    return request({
        url: serviceName + `/delete_purchase_goods`,
        method: 'post',
        data: data
    })
}

// 采购单审批
export function applyApprovalReject(data) {
    return request({
        url: serviceName + `/apply_approve_reject`,
        method: 'post',
        data: data
    })
}

// 采购单驳回后提交
export function changePurchaseState(data) {
    return request({
        url: serviceName + `/submit_xz_purchase`,
        method: 'post',
        data: data
    })
}

// 采购单入库
export function addInStore(data) {
    return request({
        url: serviceName + `/add_in_store`,
        method: 'post',
        data: data
    })
}

// 采购单待审批和已审批记录
export function purchaseApprovedList(data) {
    return request({
        url: serviceName + `/purchase_approved_list` + '?' + qs.stringify(data),
        method: 'get',
        data: data
    })
}

// 采购单记录表
export function approvalStageList(data) {
    return request({
        url: `work/approval/stage_list` + '?' + qs.stringify(data),
        method: 'get',
        data: data
    })
}

// 采购单明细-部分作废（付款后供应商缺货，作废明细对应待采购货物回退为待采购，需求 FR-CG-04 / Q1）
// TODO: 后端接口待确认，前端已按此字段结构预留
export function voidPurchaseGoods(data) {
    return request({
        url: serviceName + `/void_purchase_goods`,
        method: 'post',
        data: data
    })
}

// 采购单修改-行政发起（付款后供应商缺货，行政 48/31 发起、财务 27 执行，需求 FR-CG-05）
// TODO: 后端接口待确认，前端已按此字段结构预留
export function applyModifyPurchase(data) {
    return request({
        url: serviceName + `/apply_modify_purchase`,
        method: 'post',
        data: data
    })
}

// 采购单修改-财务执行（需求 FR-CG-05）
// TODO: 后端接口待确认，前端已按此字段结构预留
export function executeModifyPurchase(data) {
    return request({
        url: serviceName + `/execute_modify_purchase`,
        method: 'post',
        data: data
    })
}

